import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_ROUTES } from "@/api/routes";
import axios from "@/api/api";
import background from "@/assets/contacta_background.jpg";
import logo from "@/assets/logo_white.png";
import "animate.css";
import { useSession } from "@/context/SessionProvider";

export default function Login() {
    const [usuario, setUsuario] = useState("");
    const [password, setPassword] = useState("");
    const [errorLogin, setErrorLogin] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { checkSession } = useSession(); // ← Cambiar a checkSession

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const res = await axios.post(
                API_ROUTES.login,
                { usuario, password },
                { withCredentials: true }
            );


            // ⚠️ IMPORTANTE: verificar sesión (usa /auth/me)
            await checkSession(); // ← Cambiar de refreshSession a checkSession

            // Navegar al dashboard
            navigate("/dashboard");

        } catch (error) {
            console.error("❌ LOGIN fallido:", error?.response?.status, error?.response?.data); // Debug
            setErrorLogin(true);
            setTimeout(() => setErrorLogin(false), 3000);
        } finally {
            setLoading(false);
        }
    };

    const camposLlenos = usuario.trim() !== "" && password.trim() !== "";

    return (
        <div
            className="min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
            style={{ backgroundImage: `url(${background})`, backgroundColor: "#0a1b3d", backgroundBlendMode: "overlay" }}
        >
            <div className="bg-white p-8 rounded-xl shadow-lg w-[420px] relative animate__animated animate__fadeInUp">
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 animate__animated animate__fadeInDown">
                    <div className="bg-gradient-to-r from-cyan-500 to-blue-600 px-6 py-2 rounded-2xl shadow-lg">
                        <img src={logo} alt="Logo Contacta" className="h-8 w-auto object-contain" />
                    </div>
                </div>

                <form onSubmit={handleLogin} className="mt-16 space-y-4">
                    {errorLogin && (
                        <div className="animate__animated animate__shakeX bg-red-100 text-red-700 border border-red-400 px-4 py-2 rounded text-sm text-center">
                            Credenciales inválidas. Intenta nuevamente.
                        </div>
                    )}

                    <div className="relative">
                        <label className={`text-sm transition-colors ${usuario.trim() ? "text-green-600" : "text-orange-600"}`}>
                            Usuario
                        </label>
                        <input
                            type="text"
                            className={`w-full rounded px-3 py-2 mt-1 pr-3 focus:outline-none focus:ring-2 focus:ring-orange-300 bg-blue-50 transition-colors ${usuario.trim() ? "border-2 border-green-500" : "border-2 border-orange-400"}`}
                            value={usuario}
                            onChange={(e) => setUsuario(e.target.value)}
                            disabled={loading}
                            required
                        />
                    </div>

                    <div className="relative">
                        <label className={`text-sm transition-colors ${password.trim() ? "text-green-600" : "text-orange-600"}`}>
                            Contraseña
                        </label>
                        <input
                            type="password"
                            className={`w-full rounded px-3 py-2 mt-1 pr-3 focus:outline-none focus:ring-2 focus:ring-orange-300 bg-blue-50 transition-colors ${password.trim() ? "border-2 border-green-500" : "border-2 border-orange-400"}`}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            disabled={loading}
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={!camposLlenos || loading}
                        className={`w-full py-2 rounded font-semibold transition duration-300 text-white bg-gradient-to-r from-cyan-600 to-blue-600 relative z-10 overflow-hidden ${camposLlenos && !loading ? "border-2 border-green-500 animate__animated animate__pulse" : "border-2 border-transparent cursor-not-allowed"} ${camposLlenos && !loading ? "hover:shadow-lg hover:shadow-green-200" : ""}`}
                    >
                        {loading ? 'INICIANDO...' : 'INICIAR'}
                    </button>
                </form>
            </div>
        </div>
    );
}